import React from "react";

export default function FilterMenu() {
    return (
        //TODO: Implement
        <div/>
    )
}
